module.exports = __webpack_public_path__ + "img/centenario.21c7e759.png";